// A dónde vuelve el usuario después de entrar.
//
// El caso que importa: alguien buscó un técnico, tocó "pedir presupuesto" y lo
// mandamos al login. Si al entrar lo tiramos a /perfil tiene que acordarse del
// nombre del técnico y rehacer la búsqueda; casi nadie lo hace y la solicitud
// nunca llega. Por eso /ingresar y /registro aceptan ?next=/ruta.
//
// El ?next lo escribe cualquiera en la barra de direcciones, así que es entrada
// no confiable: sin validar, un enlace /ingresar?next=//otro-sitio deja al recién
// logueado en otro dominio con la sesión fresca (redirección abierta clásica).
// Solo pasan rutas internas: arrancan con "/" y no con "//" ni "/\" — el navegador
// trata las dos últimas como protocol-relative, o sea, otro host.

export const DESTINO_POR_DEFECTO = "/perfil";

export function destinoSeguro(next: string | null | undefined, alternativa = DESTINO_POR_DEFECTO): string {
  if (!next) return alternativa;
  if (!next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return alternativa;
  return next;
}

// Arma un enlace interno arrastrando el destino, para que saltar de /ingresar a
// /registro o a /recuperar no borre a dónde quería ir el usuario.
export function conNext(ruta: string, next: string): string {
  return next ? `${ruta}?next=${encodeURIComponent(next)}` : ruta;
}
